/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 14:55:14
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-26 11:02:33
 */
import { ConfigProvider } from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import App from "./App";
import { store } from "./app/store";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { ThemeContext } from "./theme/theme";
import { DefaultThemeData } from "./theme/themedata";

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <Provider store={store}>
        <ThemeContext.Provider value={DefaultThemeData}>
          <HashRouter>
            <App />
          </HashRouter>
        </ThemeContext.Provider>
      </Provider>
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
